import { createClient } from '@supabase/supabase-js'
import { API_CONFIG } from '../constants'

// Validate environment variables
if (!API_CONFIG.SUPABASE_URL) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable')
}

if (!API_CONFIG.SUPABASE_ANON_KEY) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable')
}

// Create Supabase client with configuration
export const supabase = createClient(
  API_CONFIG.SUPABASE_URL,
  API_CONFIG.SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true
    },
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'X-Client-Info': 'qmed-nursing-care-plan@1.0.0'
      }
    }
  }
)

// Utility function to handle Supabase errors
export const handleSupabaseError = (error) => {
  console.error('Supabase error:', error)

  // Provide user-friendly error messages
  if (error.message?.includes('Network')) {
    return 'Network connection error. Please check your internet connection.'
  }

  if (error.message?.includes('JWT')) {
    return 'Authentication error. Please refresh the page and try again.'
  }

  if (error.message?.includes('duplicate')) {
    return 'This record already exists.'
  }

  return error.message || 'An unexpected error occurred. Please try again.'
}

// Test Supabase connection
export const testSupabaseConnection = async () => {
  try {
    const { data, error } = await supabase
      .from('feedback')
      .select('count', { count: 'exact', head: true })

    if (error) {
      throw error
    }

    console.log('Supabase connection successful')
    return { success: true, data }
  } catch (error) {
    console.error('Supabase connection failed:', error)
    return { success: false, error: handleSupabaseError(error) }
  }
}
